import { render, staticRenderFns } from "./basicSettings.vue?vue&type=template&id=2aff9631&scoped=true&"
import script from "./basicSettings.vue?vue&type=script&lang=js&"
export * from "./basicSettings.vue?vue&type=script&lang=js&"
import style0 from "./basicSettings.vue?vue&type=style&index=0&id=2aff9631&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff9631",
  null
  
)

export default component.exports